<template>
  <div style="width: 100%;">
    <el-row style="padding: 5px;" :gutter="10">  
        <el-col :span="8">
         <el-select v-model="dutyType" :placeholder="$t('msg.pleaseSelect')" style="display:block;">
          <el-option v-for="item in dutyTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>  
        </el-col> 
        <el-col :span="13">          
          <EmployeeSearch @sync-select-employee="syncSelectEmployee" :pSelectEmp.sync="pSelectEmp" />
        </el-col> 
        <el-col :span="2" >
          <el-button type="success" @click="addTableData()" >{{$t('button.create')}}</el-button>
        </el-col> 
      </el-row>   
    <el-table ref="singleTable" :data="tableData.data"  border  highlight-current-row  :empty-text="$t('msg.noDataFound')">
      <el-table-column v-for="(v, i) in tableData.columns" :prop="v.field" :label="v.title" :width="v.width" :key="i">
        <template slot-scope="scope">
          <span v-if="v.field== 'mainChargeBol' ">
            <el-checkbox  v-model="scope.row[v.field]"  @change="checkboxChange(scope.row, scope)"></el-checkbox>
          </span>
          <span v-else>{{ scope.row[v.field] }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('action')" width="80">
        <template slot-scope="scope">    
          <el-button type="danger" @click="delTableData(scope.row, scope.$index, true)">{{$t('button.delete')}}</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {apiFindCustIncxWindows, apiFindSysAttrValueByCategory } from "../../../utils/api.js";
import authHeader from "../../../services/auth-header";
import EmployeeSearch from '../EmployeeSearch'


export default {
  props: {    
    custId: {
        type: String
    }
 
  },
  data() {   
    return {
      tableData: {
        sel: null,
        columns: [
          { field: "type", title: this.$i18n.t('field.dutyType')},         
          { field: "empNo", title: this.$i18n.t('field.empNo'), width: 200  },
          { field: "mainChargeBol", title:this.$i18n.t('field.mainCharge') }
        ],
        data: []
      },
      currentIndex:-1,
      pSelectEmp:'',
      dutyType:'',
      dutyTypeOptions: []
    };
  },  
  components: {
    EmployeeSearch
  }, 
  mounted() {    
    apiFindSysAttrValueByCategory({ headers: authHeader(), condition: 'INCX_POSITION'}).then((response) => { 
      response.data.forEach((item, index) => {   
        this.dutyTypeOptions.push({ value: item.key, label: item.key+' '+item.value });
      });
    }).catch((err) => {
      console.log(err);
    });

    if(this.custId != null && this.custId != ''){      
      
      apiFindCustIncxWindows({ headers: authHeader(), condition:this.custId}).then((response) => {         
        response.data.forEach((item, index) => {     
          item.mainChargeBol = (item.main == 1 ? true: false);
        });
        this.tableData.data = response.data;      
      }).catch((err) => {
        console.log(err);
      });
    }      
    
  },
  methods: {
    checkboxChange(row, value){
      row.action = 'U';
      debugger
      if(row.mainChargeBol){
        var isDuplicate = false;
        this.tableData.data.forEach((item, index) => {
          if(item.type == row.type && item.mainChargeBol && item.empNo != row.empNo  ){
            isDuplicate = true;
          }     
        });
        if(isDuplicate){
          this.$message({ type: "error", message: this.$i18n.t('msg.incxWindowMainChargeisDuplicate'), duration: 800});
          row.mainChargeBol = false;
        }
        
      }else{

      }
     

    },  
    addTableData() {
      if(this.dutyType != '' && this.pSelectEmp != ''){
        let isDuplicate = false;
        this.tableData.data.forEach((item, index) => {             
          if(item.type == this.dutyType && item.empNo ==this.pSelectEmp ){
            isDuplicate = true;
          }
        });
        if(isDuplicate){
          this.$message({ type: "error", message: this.$i18n.t('msg.isDuplicateCannotAdd'), duration: 800});
        }else{
          let j = {
            cust_id: this.custId,
            type: this.dutyType,
            empNo: this.pSelectEmp,
            main: '',
            action:'A',
            id:''
          };
          this.tableData.data.splice(0, 0, j);
          this.currentIndex = 0;
          this.dutyType = '';
          this.pSelectEmp = '';
        }
        
      }else{
        this.$message({ type: "error", message: this.$i18n.t('msg.selectDataFirst'), duration: 800});
         
      }
      
    },    
    delTableData(row, index){  
      this.tableData.data.splice(index, 1);
    },
    syncSelectEmployee(empNo){
      this.pSelectEmp = empNo;
    }
  }
};
</script>
